import { NavLink, useNavigate } from "react-router-dom";
import facebook from "../../assets/footer/facebook.png";
import instagram from "../../assets/footer/instagram.png";
import youtube from "../../assets/footer/youtube.png";
import { gmap } from "../Contact/ContactUs";

function Footer() {
  const navigate = useNavigate();

  function facebookProfile() {
    window.open(`https://www.facebook.com/galaxcitygadgets/`, "_blank");
  }
  function instagramProfile() {
    window.open(
      `https://www.instagram.com/galaxcitygadgets.store?igsh=MjVkYmRkb3RidWQ5&utm_source=qr/`,
      "_blank"
    );
  }
  function youTubeProfile() {
    window.open(
      `https://youtube.com/@galaxcitygadgets876?si=gjPkxRiPYzZAAbmw/`,
      "_blank"
    );
  }

  return (
    <div className="footer">
      {/* Footer upper section */}
      <div className="footer-uper">
        {/* location */}
        <div className="glass-card">
          <div className="footer-top">
            <p className="bg-titles">📍 Location</p>
          </div>
          <div>
            <p
              className="footer-desp"
              style={{ margin: "0" }}
              onClick={() => gmap()}
            >
              Galaxcity Gadgets
              <br />
              Thangal Bazar, Imphal <br />
              Manipur, Pin-795001
            </p>
          </div>
        </div>
        
        {/* page */}
        <div className="glass-card">
          <div className="footer-top">
            <p className="bg-titles">🔗 Pages</p>
          </div>
          <div>
            <p className="footer-desp" style={{ margin: "0" }}>
              <NavLink to="/" className={"footer-link"}>
                Home
              </NavLink>
            </p>
            <p className="footer-desp" style={{ margin: "0" }}>
              <NavLink to="/applestore" className={"footer-link"}>
                Apple
              </NavLink>
            </p>
            <p className="footer-desp" style={{ margin: "0" }}>
              <NavLink to="/samsungStore" className={"footer-link"}>
                Samsung
              </NavLink>
            </p>
            <p className="footer-desp" style={{ margin: "0" }}>
              <NavLink to="/marshall" className={"footer-link"}>
                Marshall
              </NavLink>
            </p>
            <p className="footer-desp" style={{ margin: "0" }}>
              <NavLink to="/muvtech" className={"footer-link"}>
                Muvtech
              </NavLink>
            </p>
          </div>
        </div>
        
        {/* brands */}
        <div className="glass-card">
          <div className="footer-top">
            <p className="bg-titles">🏷️ Brands</p>
          </div>
          <div>
            <p
              className="footer-desp"
              style={{ margin: "0" }}
              onClick={() => navigate("/applestore")}
            >
              Apple
            </p>
            <p
              className="footer-desp"
              style={{ margin: "0" }}
              onClick={() => navigate("/samsungStore")}
            >
              Samsung
            </p>
            <p
              className="footer-desp"
              style={{ margin: "0" }}
              onClick={() => navigate("/marshall")}
            >
              Marshall
            </p>
            <p
              className="footer-desp"
              style={{ margin: "0" }}
              onClick={() => navigate("/muvtech")}
            >
              Muvtech
            </p>
          </div>
        </div>
        
        {/* subscribe */}
        <div className="footer-sub-container glass-card">
          <div className="footer-top">
            <p className="bg-titles">📧 Subscribe</p>
          </div>
          <div>
            <p className="footer-desp" style={{ marginBottom: "8px" }}>
              🔥Don't miss out! Subscribe for latest <br />
              Products and Special Deals
            </p>
          </div>
          <div className="footer-outer-sub">
            <div className="footer-sub">
              <input
                type="text"
                name="mail"
                id="email"
                className="glass-input"
                placeholder="xyz@gmail.com"
              />
              <button className="glass-button">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* footer lower section */}
      <div className="footer-lower">
        {/* social media */}
        <div className="social-media glass-card">
          <div className="footer-bottom">
            <p className="bg-titles">🌐 Social Media</p>
          </div>

          {/* social media logo  */}
          <div className="socail-media-box">
            <div
              className="footer-media-box"
              onClick={() => facebookProfile()}
              style={{ cursor: "pointer" }}
            >
              <img src={facebook} alt="Facebook" width="100%" />
            </div>
            <div
              className="footer-media-box"
              onClick={() => instagramProfile()}
              style={{ cursor: "pointer" }}
            >
              <img src={instagram} alt="instagram" width="100%" />
            </div>
            <div
              className="footer-media-box"
              onClick={() => youTubeProfile()}
              style={{ cursor: "pointer" }}
            >
              <img src={youtube} alt="youtube" width="100%" />
            </div>
          </div>
        </div>
      </div>

      {/* Copyrights */}
      <div className="copyrights-box">
        <div className="glass-card" style={{ textAlign: 'center', padding: '1.5rem' }}>
          <p style={{ marginBottom: "8px", fontSize: '16px', fontWeight: '600' }}>
            © 2025 Galaxcity. All Rights Reserved
          </p>
          <p style={{ marginBottom: '12px', fontSize: '14px' }}>
            Powered by Saino Team
          </p>
          <p style={{ fontSize: "12px", color: "rgba(255, 255, 255, 0.7)", lineHeight: '1.4' }}>
            Disclaimer: All product images and brand logos are property of their
            respective owners. Our team does not claim ownership of these images;
            they are provided by the client or sourced from official brand
            websites. The client is not the owner of the brands or trademarks
            displayed, and all trademarks remain the property of their respective
            trademark holders. Use of these images does not imply any affiliation
            with or endorsement by the respective brand owners.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
